import { useRef } from 'react'

import { useRegisterReload } from '../../../../../hooks'

import { getRequestBoardReloadItemId } from './useRequestBoardItemReload.utils'

export function useRequestBoardItemReload({
  isPerformingMassAction,
  onCallAction,
  onRegisterItemReload,
  onReload,
  onReloadItem,
  onStartAction,
}) {
  const actedItemRef = useRef(null)

  function handleCallAction(action, item) {
    if (!isPerformingMassAction) {
      actedItemRef.current = { action, id: item.id }

      onStartAction(item.id)

      onCallAction(action, item)
    }
  }

  async function handleReloadItem(mutatedItemId) {
    const itemId = getRequestBoardReloadItemId({
      actedItem: actedItemRef.current,
      mutatedItemId,
    })

    actedItemRef.current = null

    return itemId ? onReloadItem(itemId) : onReload()
  }

  useRegisterReload({
    reload: handleReloadItem,
    onRegisterReload: onRegisterItemReload,
  })

  return { handleCallAction }
}
